/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ chain: NonNullable<unknown>, date: NonNullable<unknown> }} Tooltip_Card_CalculatedInputs */



/**
* | output |
* | --- |
* | "Activity from the {chain} chain is included.<br /><br />Last calculated on<br />{date}" |
*
* @param {Tooltip_Card_CalculatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tooltip_card_calculated = /** @type {((inputs: Tooltip_Card_CalculatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_Card_CalculatedInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Activity from the ${i?.chain} chain is included.<br /><br />Last calculated on<br />${i?.date}`)
});